let $ = jQuery
const Global = {
  cacheBody() {
    return document.querySelector('body');
  },
  postAjax(dataObj, files = false) {
    let ajaxOptions = {
      type: 'POST',
      url: phpObj.ajaxPath,
      data: dataObj,
      dataType: 'json',
      error(err) {
        console.log(err);
        return err
      }
    }
    let ajaxOptionsWithFiles = {
      url: phpObj.ajaxPath,
      type: 'POST',
      contentType: false,
      processData: false,
      data: dataObj,
      error(err) {
        console.log(err);
        return err
      },
      cache: false

    }
    let options = files ? ajaxOptionsWithFiles : ajaxOptions;
    return $.ajax(options);
  }
}
module.exports = Global


// WEBPACK FOOTER //
// ./library/src/js/globals/avista-global.js